import React from 'react';
import './Footer.css';

const Footer = () =>
  <div className="footer hidden-mobile">
    <a href="https://github.com/Neilblaze/speakit" target="_blank" rel="noopener noreferrer">
      view source
    </a>
    <a href="https://github.com/Neilblaze" target="_blank" rel="noopener noreferrer">
      © Neilzblaze
    </a>
  </div>;

export default Footer;
